export const TARGETS_QUERY_KEY = "targets"
export const TARGET_DETAILS_QUERY_KEY = "target-details"
export const TARGET_NEAREST_STATIONS_QUERY_KEY = "target-nearest-stations"
export const TARGET_TEMPLATES_PAGED_QUERY_KEY = "templates-paged"
